// extracted by css-extract-rspack-plugin
export default {"actionsLabel":"lGBCp2qf8aAVdxfD","itemLabel":"DewByWR84IIzEbOh"};